import { createAction } from 'redux-actions';
import * as Api from '../api/communication';

const requestMaintenanceCommunication = createAction('MAINTENANCE_COMMUNICATION_REQUEST');
const receiveMaintenanceCommunication = createAction('MAINTENANCE_COMMUNICATION_SUCCESS');
const failMaintenanceCommunication = createAction('MAINTENANCE_COMMUNICATION_ERROR');

export const fetchMaintenanceCommunication = () => dispatch => {
   dispatch(requestMaintenanceCommunication());

   return Api.getMaintenanceCommunication().then(
      data => dispatch(receiveMaintenanceCommunication({ data })),
      error => dispatch(failMaintenanceCommunication(error))
   );
};
